/**
 * The chrome for Or's design: white 72px bar, 1120px rail, one-line footer.
 *
 * Deliberately NOT a variant of CampaignShell. The two differ in background,
 * height, rail width, nav weight and footer, so sharing one component would
 * mean every line carrying a condition.
 */

import React, { useEffect } from 'react';
import CampaignConsent from '../CampaignConsent';
import { ensureCampaignTag } from '../../../analytics/campaignTag';
import './CampaignMock.css';

export default function MockShell({ audience, onBackToList, onRequestDemo, rail, centered, children }) {
  // Three rails, measured off the mockup: 1120 for the journey (the
  // default in CSS), 850 for FAQ and Pricing, 570 and centred for the demo
  // form. Set as a width rather than looked up from a class, so a fourth
  // measurement is a number at the call site and not a new CSS rule.
  // Same boot as the other shell: campaign routes only.
  useEffect(() => { ensureCampaignTag(); }, []);

  return (
    <div className="mk">
      <header className="mk-head">
        <div className="mk-wrap mk-head-inner">
          <img
            src="/textOnlyLogoOrr-01.png"
            alt="Alchemiq"
            className="mk-logo"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <span className="mk-tag">The relevance engine</span>
          <nav className="mk-nav">
            {onBackToList && (
              <button type="button" onClick={onBackToList}>Back to my opportunities</button>
            )}
            {audience && (
              <>
                <a href={`/c/${audience}/faq`}>FAQ</a>
                <a href={`/c/${audience}/pricing`}>Pricing</a>
                {/* The mockup carries "Request a demo" in the header on every
                    screen, where the other design keeps it in the footer. */}
                {onRequestDemo
                  ? <button type="button" onClick={onRequestDemo}>Request a demo</button>
                  : <a href={`/c/${audience}/demo`}>Request a demo</a>}
              </>
            )}
          </nav>
        </div>
      </header>

      <main className="mk-main">
        <div
          className={`mk-wrap${centered ? ' mk-center' : ''}`}
          style={rail ? { maxWidth: rail } : undefined}
        >
          {children}
        </div>
      </main>

      <footer className="mk-foot"><div className="mk-foot-inner">Alchemiq</div></footer>
      {/* The cookie notice is a legal control and appears in both designs. */}
      <CampaignConsent skin="mk" />
    </div>
  );
}
